import { useMemo } from 'react';
import { useLastReadModule } from '../../context/LastReadContext';
import { isItemUnread } from './lastReadUtils';

/**
 * Derive unread item ids for the current paginated list page from lastRead + activity timestamps.
 */
export function useUnreadItemIds(module, items, options = {}) {
  const {
    getItemId = (item) => item.id,
    getActivityAt = (item) => item.createdAt,
    isEligible = () => true,
    neverOpenedDefault = null,
  } = options;

  const { lastReadMap } = useLastReadModule(module);

  return useMemo(() => {
    const unreadIds = [];

    items.forEach((item) => {
      if (!isEligible(item)) return;

      const itemId = getItemId(item);
      const readAt = lastReadMap[itemId];

      if (isItemUnread({
        activityAt: getActivityAt(item),
        readAt,
        neverOpenedDefault,
      })) {
        unreadIds.push(itemId);
      }
    });

    return unreadIds;
  }, [items, lastReadMap, getItemId, getActivityAt, isEligible, neverOpenedDefault]);
}
